import React from "react";
import { Link } from "react-router-dom";

const LeftMenu = () => {
  return (
    <div className=" w-72">
      <ul>
        <li>
          <Link to={"/dashboard"}>Dashboard</Link>
        </li>
        <li>
          <Link to={"/challenges"}>Challenges</Link>
        </li>
        <li>
          <Link to={"/districts"}>Districts</Link>
        </li>
        <li>
          <Link to={"/create-visit-task"}>Create Visit Tasks</Link>
        </li>
        <li>
          <Link to={"/unpublished-challenges"}>Unpublished Challenges</Link>
        </li>
      </ul>
    </div>
  );
};

export default LeftMenu;
